// Module
var code = `<form novalidate name="\$ctrl.form">
  <table class="table">
    <thead>
      <th id="no_th">No.</th>
      <th id="role_th">Role name</th>
      <th id="name_th">Name</th>
      <th id="action_th" ng-if="\$ctrl.editMode">Action</th>
    </thead>
    <tbody class="tbody">
      <tr ng-repeat="officer in \$ctrl.officers">
        <td>{{ \$index+1 }}</td>
        <td>{{ officer.role | prettyEnum }}</td>
        <td>{{ officer.effectiveName }}</td>
        <td ng-if="\$ctrl.editMode">
          <button class="btn btn-info" ng-click="\$ctrl.removeCenterOfficer(officer)">
            Remove
          </button>
        </td>
      </tr>
      <tr ng-if="\$ctrl.profile.customers.length !== 0 && \$ctrl.editMode">
        <td>
          {{\$ctrl.officers.length + 1}}.
        </td>
        <td>
          <select
            ng-model="\$ctrl.role"
            ng-options="role.value as role.label for role in \$ctrl.getUnassignedRoles()">
          </select>
        </td>
        <td>
          <select
            ng-model="\$ctrl.user"
            ng-options="customer as customer.effectiveName for customer in \$ctrl.getUnassignedCustomers()">
          </select>
        </td>
        <td ng-if="\$ctrl.editMode">
          <button class="btn btn-info" ng-click="\$ctrl.addCenterOfficer()" ng-disabled="!\$ctrl.canAdd()">
            Add
          </button>
        </td>
      </tr>
    </tbody>
  </table>


  <div class="clearfix"></div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/center/officers/center-officers.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;